import {
  ClickAwayListener,
  Drawer,
  Slide,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useEffect } from "react";
import LoadingIcon from "../../LoadingIcon";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../providers/AuthProvider";
import api from "../../../utils/api";
import useIsMobileDevice from "../../../utils/mobileCheck";
import iconNotificationReaded from "../../../assets/icons/icon-notification-readed.svg";
import iconNotificationUnreaded from "../../../assets/icons/icon-notification-unreaded.svg";

import "./ContentContainer.css";

export const ContentContainer = ({
  styles,
  children,
  notificationsVisible,
  setNotificationsVisible,
  loading,
  notifications,
  setNotifications,
}) => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleClick = async (notification) => {
    try {
    await api.put(
        `/talents/notifications/${notification.notificationId}/readed`
      );

      setNotifications((currentNotifications) => {
        const updatedNotications = currentNotifications.reduce(
          (acc, currentItem) => {
            if (currentItem.notificationId === notification.notificationId) {
              acc.push({ ...currentItem, readed: true });
            } else {
              acc.push(currentItem);
            }
            return acc;
          },
          []
        );
        return updatedNotications;
      });

      if (notification.notificationType === "new_message") {
        navigate(`/chat/${notification.referenceId}`);
      }
    } catch (error) { console.log(error);
    }
  };

  const readAll = async () => {
    try {
    //  await api.put(
    //     `/talents/notifications/${notification.notificationId}/readed`
    //   );

    // console.log(notifications);


      setNotifications((currentNotifications) => {
        const updatedNotications = currentNotifications.reduce(
          (acc, currentItem) => {
            if (currentItem.readed === false) {
              acc.push({ ...currentItem, readed: true });
            } else {
              acc.push(currentItem);
            }
            return acc;
          },
          []
        );
        return updatedNotications;
      });

      //console.log(data);
    } catch (error) {}
  };

  const isMobile = useIsMobileDevice();

  const NotificationCard = ({ notification }) => {
    return (
      <Box
        className="notificationCard"
        sx={{
          ":hover": {
            opacity: notification?.readed ? "35%" : "75%",
          }
        }}
        onClick={() => {
          handleClick(notification);
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            gap: "8px",
            alignItems: "center",
          }}
        >
          <img
            src={notification.readed ? iconNotificationReaded : iconNotificationUnreaded}
            alt=""
            style={{ width: "14px", height: "14px" }}
          />
          <div className={`titleNotifications ${notification.readed ? "" : "titleNotificationsUnreaded"}`}>{notification.title}</div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            marginTop: "10px",
            marginBottom: "20px",
          }}
        >
          <div className="subTitleNotifications">{notification.subtitle}</div>
        </div>
      </Box>
    );
  };

  function isMobileDevice() {
    return window.innerWidth <= 800;
  }

  return (
    <div
      component="main"
      sx={{
        flexGrow: 1,
        // minHeight: "100vh",
        overflow: "hidden",
        overflowX: "hidden",
        // paddingTop: 12,
        display: "flex",
        justifyContent: "center",
        // marginBottom: '40px'
      }}
    >
      {user.userType === "admin" ? null : (
        <Box
          sx={{
            position: "fixed",
            width: "282px",
            display: "flex",
            justifyContent: "flex-end",
            pointerEvents: "none",
          }}
          className="modalNotifications"
        >
          <ClickAwayListener
            mouseEvent="onMouseDown"
            onClickAway={() =>
              notificationsVisible ? setNotificationsVisible(false) : null
            }
          >
            <Slide
              in={notificationsVisible}
              {...(notificationsVisible ? { timeout: 500 } : {})}
            >
              <div>
                {loading ? (
                   <div
                   style={{
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                     height: "150px",
                     marginTop: "50px",
                   }}
                 >
                   <LoadingIcon />
                 </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "22px",
                    }}
                  >
                    <Drawer
                      variant="temporary"
                      open={notificationsVisible}
                      onClose={() => setNotificationsVisible(false)}
                      sx={{
                        // width: 180,
                      }}
                      anchor="top"
                      PaperProps={{
                        style: {
                          backgroundColor: "#fff",
                          maxHeight: "50vh",
                          padding: "30px",
                          margin: isMobileDevice() ? "30px": 'auto',
                          marginTop: isMobileDevice() ? "80px" : "150px",
                          borderRadius: "5px",
                          width: !isMobileDevice() && '320px'},
                      }}
                    >
                      <div className="containerNotifications">
                        {notifications && notifications?.length > 0 ? (
                          <div style={{ height: "60vh"}}>
                            <div
                              style={
                                {
                                  // paddingBottom: "10px",
                                  // borderBottom: "1px solid #BFB7B8",
                                }
                              }
                            >
                              <button
                                color="primary"
                                variant="outlined"
                                style={{ textTransform: "none" }}
                                onClick={() => readAll()}
                                className="buttonNotifications"
                              >
                                Marcar todas como lidas
                              </button>
                            </div>
                            <div>
                              {notifications.map((item, index) => (
                                <NotificationCard
                                  notification={item}
                                  key={index}
                                />
                              ))}
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "20vh",
                            }}
                          >
                            {/* <NotificationsOff
                              fontSize="large"
                              sx={{ color: "#57BAB8" }}
                            /> */}

                            <div className="titleNotificationsNOt">Nenhuma notificação encontrada</div>
                          </div>
                        )}
                      </div>
                    </Drawer>
                  </div>
                )}
              </div>
            </Slide>
          </ClickAwayListener>
        </Box>
      )}
      <div style={{ ...styles }} className="containerBoxNotifications">{children}</div>
    </div>
  );
};
